import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import atomize from "@quarkly/atomize";
import { AbstractLink } from "../utils/abstractLink";
import isEmptyChildren from "../utils/isEmptyChildren";
import Placeholder from "./placeholder";

var LinkBox = function LinkBox(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(AbstractLink, rest, isEmptyChildren(children) && /*#__PURE__*/React.createElement(Placeholder, {
    message: "DROP HERE"
  }), children);
};

export default atomize(LinkBox)({
  name: "LinkBox",
  effects: {
    link: ":link",
    hover: ":hover",
    visited: ":visited",
    active: ":active",
    firstChild: ":first-child",
    lastChild: ":last-child",
    onlyChild: ":only-child",
    firstOfType: ":first-of-type",
    lastOfType: ":last-of-type",
    onlyOfType: ":only-of-type",
    before: ":before",
    after: ":after",
    firstLine: "::first-line",
    firstLetter: "::first-letter",
    selection: "::selection",
    empty: ":empty"
  },
  forwardCssProperties: false,
  normalize: true,
  mixins: true,
  description: {
    en: "Text element — text in different variants: paragraph, heading, etc.",
    ru: "Элемент text — текст в различных вариантах: параграф, заголовок, и другие"
  },
  propInfo: {
    href: {
      weight: 1,
      control: "href",
      category: "Main",
      description: {
        en: "href — destination address where the link takes to",
        ru: "href — адрес назначения, по которому направляет ссылка"
      }
    },
    target: {
      weight: 1,
      control: "select",
      variants: ["_self", "_blank", "_parent", "_top"],
      category: "Main"
    }
  }
}, {
  "text-decoration-line": "initial",
  "align-items": "center",
  "flex-direction": "column",
  "justify-content": "center",
  color: "initial",
  display: "flex",
  "empty-border-width": "1px",
  "empty-border-style": "solid",
  "empty-border-color": "LightGray",
  "empty-min-width": "64px",
  "empty-min-height": "64px",
  href: "#"
});